"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "m19.202 11.343-6.482 6.364c-.398.39-1.042.39-1.441 0l-6.48-6.364a.987.987 0 0 1 0-1.414 1.032 1.032 0 0 1 1.44 0l4.743 4.657V3A1.01 1.01 0 0 1 12 2a1.01 1.01 0 0 1 1.018 1v11.586l4.744-4.657a1.032 1.032 0 0 1 1.44 0 .987.987 0 0 1 0 1.414Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M19.5 18.093v-2.39c0-.388.336-.703.75-.703s.75.315.75.703v2.813c0 .045-.005.09-.014.135a.77.77 0 0 1 .014.146c0 .388-.288.703-.643.703H3.643c-.355 0-.643-.315-.643-.703a.77.77 0 0 1 .014-.146.672.672 0 0 1-.014-.135v-2.813c0-.388.336-.703.75-.703s.75.315.75.703v2.39h15Z"
  })]
});